<template>
  <cube-divider position="left">
    <view class="divider-slot">This is slot text</view>
  </cube-divider>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({})
</script>

<style lang="stylus">
.divider-slot
  color #fc9153
  font-size 12px
  padding-left 10px
  padding-right 10px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index"
    }
  }
</script>